import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import { CostService } from "../../../services/index";
import * as fromRootStore from "../../../reducers";
import {
  ComboService,
  SampleService
} from "../../../services/index";

@Component({
  selector: "AddEditDSample",
  templateUrl: "./AddEditDSample.html",
})
export class AddEditDSample {
  auto_number: number;
  season_name: string;
  row: any;
  data: any;

  qualityList: any;
  typeList: any;
  coreList: any;
  shadeIndex: number = 0;
  gangList: any;
  coredesignList: any;
  gangdesignList: any;
  shadeTypeList: any = [];
  shadeTypeListExists: any = [];
  purchaseAgentList = [];
  seasonList = [];
  designColors: any = [];
  detailList: any = [];
  categoryData: any = [];
  saveDetect: boolean = false
  filter: any = {
    season: "",
    date: "",
    ref_no: "",
    shirt_no: "",
    dhoti_no: "",
    combo_name: "",
    style: "",
    variety: "",
    dp_shirt: 0,
    dp_dhoti: 0,
    margin: 0,
    combo_mrp: 0,
    fs_rate: 0,
    hs_rate: 0,
    category: ""
  };

  designnoList = [];
  dhotiNoList = [];
  comboDetails = [];


  shadeType = "";
  shadeColor = "";
  widthList: any[];
  designTypeList = ["NEW", "CORE", "GANG"];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);

    if (this.mode == "Edit" || this.mode == "View") {
      this.filter = designdata;
      this.filter.date = designdata.ref_date;
      this.loadeditsamplelist();
    }
  }

  get params(): any[] {
    return this._params;
  }

  get validData() {
    return this.filter.shirt_no && this.filter.dhoti_no && this.filter.combo_name ? true : false;
  }

  @Output() tabUpdateEvent = new EventEmitter();
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  filteredOptions: Observable<string[]>;
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private costservice: CostService,
    private sampService: SampleService,
    private comboservice: ComboService,
  ) { }
  ngOnInit() {
    this.getCategory();
    if (this.mode == "Add") {
      this.getAuto();
      this.getSeasonList();
      this.getDesignNoList();
      this.getPoDhotiList();
      this.filter.date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    }
    this.tableScroll();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#date").focus();
    }, 100);
  }
  tableScroll() {
    $(".purreturn").height(window.innerHeight - 60);
    $(".pobody").width(window.innerWidth - 30);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getAuto() {
    this.sampService.getAutoDhotiRefNumber({}).then((res: any) => {
      this.filter.ref_no = res;
    });
  }

  getSeasonList() {
    let params = {
      date: new Date().getFullYear(),
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSeason(params).then((res: any) => {
      let partialSeason = [];

      for (let i = res.length - 1; i > res.length - 10; i--) {
        partialSeason.push(res[i]);
      }

      let today = new Date();
      let curDate =
        today.getFullYear() +
        "-0" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();

      res.forEach((el) => {
        if (curDate >= el.order_from && curDate <= el.order_to) {
          this.filter.season = el.season;
        }
      });

      this.seasonList = partialSeason;
    });
  }

  getDesignNoList() {
    let params = {};
    this.comboservice.getDesignCombo(params).then((res: any) => {
      this.designnoList = res;
    });
  }

  getPoDhotiList() {
    let params = {};
    this.comboservice.getPoDhotiNoList(params).then((res: any) => {
      this.dhotiNoList = res;
    });
  }

  getCategory() {
    let that = this,
      params = {
        brand: '',
      };
    that.costservice.getCategory(params).then((res: any) => {

      if (res.data.length > 0) {
        that.categoryData = res.data;
      }
    });
  }

  addComboDhoti() {
    let params = {
      combo_name: this.filter.combo_name,
      shirt_no: this.filter.shirt_no,
      dhoti_no: this.filter.dhoti_no
    }
    this.sampService.checkDhotiexist(params).then((res: any) => {
      if (res.success) {
        this.designColors = res.data;
        this.filter.dp_shirt = this.designColors.shirtArr[0].mrp;
        this.filter.dp_dhoti = this.designColors.dhotiArr[0].mrp;
        this.filter.style = this.designColors.dhotiArr[0].style;
        this.filter.variety = this.designColors.dhotiArr[0].type;
        this.addRow();
        this.calcDhotiMrp();
      } else {
        swal("ERROR", res.message, "error");
      }
    });
  }

  calcDhotiMrp() {
    this.filter.combo_mrp = Number(this.filter.dp_shirt) + Number(this.filter.dp_dhoti) + Number(this.filter.margin);
    this.saveDetect = false;
    const category = this.categoryData.filter((data) => Number(data.mrp) == Number(this.filter.combo_mrp));
    if (category.length > 0) {
      this.saveDetect = true;
      this.filter.category = category[0].category;
      this.filter.fs_rate = category[0].fs_rate;
      this.filter.hs_rate = category[0].hs_rate;
    } else {
      this.filter.category = "";
      this.filter.fs_rate = "";
      this.filter.hs_rate = "";
    }
  }

  loadeditsamplelist() {
    let params = {
      combo_id: this.filter.combo_id,
      dhoti_no: this.filter.dhoti_no,
      shirt_no: this.filter.shirt_no
    };
    this.sampService.getEditdhotiSampleList(params).then((res: any) => {
      if (res.success && res.data.details.length > 0) {
        this.comboDetails = res.data.details;
        this.designColors = res.data;
        this.filter.fs_rate = res.data.details[0].fsrate;
        this.filter.hs_rate = res.data.details[0].hsrate;
        this.filter.category = res.data.details[0].category;
        this.saveDetect = true;
      }
    });
  }

  onSelectItem(field: string, color: string, ind: number) {
    const colorList = this.comboDetails.filter((data) => data[field] == color);
    if (colorList.length > 1) {
      swal({
        type: "error",
        titleText: "Color already exist",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
      this.comboDetails[ind][field] = "";
    }

    if (field == "shirt_color") {
      this.comboDetails[ind].combo_color = color;
    }
  }

  addRow(combo?: any) {
    if (!this.comboDetails.length || (combo && combo.shirt_color && combo.dhoti_color && combo.combo_color)) {
      if (!this.comboDetails.length || (this.comboDetails[this.comboDetails.length - 1].shirt_color || this.comboDetails[this.comboDetails.length - 1].dhoti_color || this.comboDetails[this.comboDetails.length - 1].combo_color)) {
        const data = { shirt_no: this.filter.shirt_no, shirt_color: "", dhoti_no: this.filter.dhoti_no, dhoti_color: "", combo_name: this.filter.combo_name, combo_color: "" };
        this.comboDetails.push(data);
      }
    } else {
      swal({
        type: "error",
        titleText: "Please select color",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 2000
      });
    }
  }

  deleteRow(index: number) {
    this.comboDetails.splice(index, 1);
    if (!this.comboDetails.length) {
      this.clearComboDetails();
    }
  }

  clearComboDetails() {
    this.comboDetails = [];
    this.filter.dp_shirt = 0;
    this.filter.dp_dhoti = 0;
    this.filter.margin = 0;
    this.filter.combo_mrp = 0;
    this.filter.category = "";
    this.filter.fs_rate = 0;
    this.filter.hs_rate = 0;
    this.saveDetect = false;
  }

  addDSample() {
    for (const data of this.comboDetails) {
      if (!data.shirt_color || !data.dhoti_color || !data.combo_color) {
        swal("ERROR", "Please select required fields", "error");
        return;
      }
    }

    this.filter.date = this.datePipe.transform(this.filter.date, "yyyy-MM-dd");

    let that = this;

    let params: any = Object.assign({}, this.filter);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.comboDetails);

    swal({
      title: "Are you sure to save this Dhoti Sample?",
      type: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.sampService.addDhotiSampleInward(params).then(function (res: any) {
        if (res.success) {
          that.toasterService.pop({
            bodyOutputType: 1,
            type: "success",
            title: "SUCCESS",
            body: "Dhoti sample saved successfully",
          });
          let tabObj = {
            action: "CloseTab",
            params: {},
          };
          that.tabUpdateEvent.emit(tabObj);
          that.saveEvent.emit(tabObj);
        } else {
          swal("ERROR", res.message, "error");
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/sample/AddEditDSample.ts